export const applicationLayoutFooterStore = {
     namespaced: true,
   
     state: {
       isFooterHidden: false, // Footer visibility
     },
   
     getters: {
       isFooterHidden: (state: any) => state.isFooterHidden,
     },
   
     mutations: {
       SET_IS_FOOTER_HIDDEN(state: any, value: boolean) {
         state.isFooterHidden = value;
       },
     },
   
     actions: {
       setIsFooterHidden({ commit }: any, value: boolean) {
         commit('SET_IS_FOOTER_HIDDEN', value);
       },
     },
};